export const SET_REGISTRATION_STATUS = "REGISTER/SET_REGISTRATION_STATUS";

export const setRegistrationStatus = (status: string) => ({
    type: SET_REGISTRATION_STATUS,
    payload: {
        registrationStatus: status
    }
});